import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function E() {
    const { useLang } = useGlobal();
    const { t } = useLang('homebattery');
    return (
        <div id="E" className={`home-battery-E home-battery-box ${css['home-battery-E']}`}>
            <h2 className="title">{t('secE_title')}</h2>
            <div className="img-box">
                <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718950031822/img05.jpg" alt={t('secE_title')} />
            </div>
            <p className="desc">
                {t.rich('secE_desc', {
                    s: (text: string) => <span className="strong">{text}</span>,
                })}
            </p>
        </div>
    );
}
